// extracted by mini-css-extract-plugin
module.exports = {"commentComposer":"TabComments_commentComposer__EB2gL","textNoMoreComments":"TabComments_textNoMoreComments__9na06"};